/**
 * Created by Ning Jiang on 2021-09-17.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DeadwoodRip} from "../DeadwoodRip";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {DeadwoodRipGameConfig} from "../DeadwoodRipGameConfig";
import {XBetView} from "./XBetView";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";

export class XBetController extends PIXI.Container {

    // this._state.tint = 0xFFbf44;
    // this._state.tint = 0xFF0000;
    //     DeadwoodRipSound.soundPlayer.playTrack({
    //     name : this.selectedIndex > 0 ? DeadwoodRipSound.XBET_ON : DeadwoodRipSound.XBET_OFF,
    //     volume : 1
    // });

    public static boostedNames:string[] = ["BOOSTED_BET", "BOOSTED_BET_2"];

    private _view:XBetView;

    private _featureAllowed:boolean;

    private _featureVisible:boolean = false;
    public set featureVisible(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }

        this._featureVisible = value;
        this._view.featureVisible = this._featureVisible;
    }

    private _selectedIndex:number = 0;
    public set selectedIndex(value:number) {
        if(!this._featureAllowed) {
            return;
        }

        if(value != this._selectedIndex) {
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.XBET[value]});
        }

        this._selectedIndex = value;
        this._view.selectedIndex = this._selectedIndex;

        // selectedIndex can only change for normal mode
        if(DeadwoodRip.model.data.nextMode === GameMode.NORMAL) {
            DeadwoodRip.reels.forEach(reel => {
                reel.setCurrentReelSet(DeadwoodRipGameConfig.getReelSetName(DeadwoodRip.model.data.nextMode));
            });
        }
    }

    public get selectedIndex() {
        return this._selectedIndex;
    }

    constructor() {
        super();

        this._featureAllowed = SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        if(!this._featureAllowed) {
            return;
        }

        this._view = new XBetView();
        SlotGame.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => this.onSelectedFeatureBetChanged());
    }

    private onSelectedFeatureBetChanged():void {
        const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();

        if(activeBetFeature && XBetController.boostedNames.includes(activeBetFeature.name)) {
            this.selectedIndex = XBetController.boostedNames.indexOf(activeBetFeature.name) + 1;
        } else {
            this.selectedIndex = 0;
        }
    }

    public start():void {
        if(!this._featureAllowed) {
            return;
        }

        const nextMode = DeadwoodRip.model.data.nextMode;
        this.featureVisible = nextMode === GameMode.NORMAL;
        this.onSelectedFeatureBetChanged();
    }
}
